/* eslint-disable @typescript-eslint/no-unused-vars */
import { toast } from "react-toastify";
import { store } from "../app/store";
import { addNotification } from "../features/auth/notificationSlice";
import { useAppDispatch } from "../hooks/reduxHooks";


export interface NotificationMessage<T = unknown> {
    _id?: string;

    userId?: string;

    type: string;

    title?: string;

    message?: string;

    entityId?: string;

    route?: string;

    data?: any;

    isRead?: boolean;

    createdAt?: string;

    updatedAt?: string;
}
let socket: WebSocket | null = null;

export function connectSocket(onConnected?: () => void) {
   
    if (socket) {
        return socket;
    }


     const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "ws://localhost:5000";
    socket = new WebSocket(SOCKET_URL);
       

    socket.onopen = () => {
        console.log(" Connected to WebSocket Server");  

        //  Call callback AFTER the socket is connected
        onConnected?.();
    };
    

    socket.onmessage = (event) => {
        const data: NotificationMessage = JSON.parse(event.data);
        if(data.type === "Assign-Project"){
          store.dispatch(addNotification(data));
        //  toast.info(`${data.title}: ${data.message}`);
        toast.info(`A new project ${data?.data?.projectName} has been assgined`)
        }
        if(data.type === "password-reset"){
            store.dispatch(addNotification(data));
            toast.info(data?.message || "Pasword Update By Admin")
        }

        // console.log("Received:", data);
    };

    socket.onclose = () => {
        console.log(" WebSocket Closed");

        socket = null;
    };

    socket.onerror = (error) => {
        console.log(" Socket Error:", error);
    };

    return socket;
}


export function sendMessage(data: NotificationMessage) {

    if (!socket) {
        console.log("Socket not connected");
        return;
    }

    //  Prevent sending while still connecting
    if (socket.readyState !== WebSocket.OPEN) {
        console.log("Socket is still connecting...");
        return;
    }

    socket.send(JSON.stringify(data));
}

export function disconnectSocket() {
    socket?.close();
}